"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const serviceConfigs_1 = require("@configs/serviceConfigs");
const Board_1 = __importDefault(require("@containers/common/Board"));
const InputLabel_1 = __importDefault(require("@containers/common/InputLabel"));
const uiFlowUtils_1 = require("@containers/common/utils/uiFlowUtils");
const Button_1 = __importDefault(require("@modules/Button"));
const ButtonWrapper_1 = __importDefault(require("@modules/ButtonWrapper"));
const Grid_1 = __importDefault(require("@modules/Grid"));
const react_1 = __importDefault(require("react"));
const react_hook_form_1 = require("react-hook-form");
const react_redux_1 = require("react-redux");
const model_1 = require("../model");
const data_1 = require("../model/data");
const pageService_1 = require("../service/pageService");
const SearchForm = (props) => {
    var _a;
    const { setPageRoutes, pageRoutes } = props;
    const dispatch = (0, react_redux_1.useDispatch)();
    const { apiStatus } = (0, react_redux_1.useSelector)((state) => (Object.assign({}, state.df0001)));
    const [searchFormData, setSearchFormData] = react_1.default.useState(data_1.searchFormField);
    const { register, formState: { errors }, handleSubmit, reset } = (0, react_hook_form_1.useForm)({ mode: 'onBlur', reValidateMode: 'onBlur' });
    const handleOnChange = (props) => {
        var _a;
        const dataTarget = (_a = props.target) !== null && _a !== void 0 ? _a : props;
        const { name: inputName, value: inputValue } = dataTarget;
        if (inputName === 'limit') {
            const newValue = (0, pageService_1.replaceChinese)(inputValue);
            setSearchFormData(Object.assign(Object.assign({}, searchFormData), { [inputName]: newValue }));
        }
        setSearchFormData(Object.assign(Object.assign({}, searchFormData), { [inputName]: inputValue }));
    };
    const handleSubmitForm = () => {
        dispatch((0, model_1.FETCH_SEARCH)(searchFormData));
    };
    const handleClearSearchForm = () => {
        reset(Object.assign({}, data_1.searchFormField));
        dispatch((0, model_1.SET_SEARCH_RESULT)([]));
        (0, uiFlowUtils_1.handleRefreshMainPage)(setPageRoutes, pageService_1.initPageRoutes);
    };
    /**
     * 動作完成後，重新查詢列表
     */
    react_1.default.useEffect(() => {
        const { code } = apiStatus;
        if (code === serviceConfigs_1.HTTP_STATUS_CODE.OK) {
            (0, uiFlowUtils_1.handleRefreshSearchPage)(setPageRoutes, pageRoutes);
        }
    }, [apiStatus]);
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "wrapper" }, { children: (0, jsx_runtime_1.jsxs)(Board_1.default, Object.assign({ title: "\u67E5\u8A62", titlePosition: "left", handleToggleExpand: () => (0, uiFlowUtils_1.handleClickExpand)(setPageRoutes, pageRoutes, 'searchForm'), isContentShow: pageRoutes.searchForm.isExpand, isShowToggleLineHeightButton: true }, { children: [(0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ row: true }, { children: (0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ col: true, xs: "12", sm: "12", md: "12", lg: "12", xl: "12", xxl: "12" }, { children: (0, jsx_runtime_1.jsx)(InputLabel_1.default, { type: "number", label: "\u67E5\u8A62\u4EBA\u6578", name: "limit", onChange: handleOnChange, required: true, register: register, messages: {
                                required: '查詢人數為必填選項',
                                maxLength: '長度必須小於 2'
                            }, message: (errors === null || errors === void 0 ? void 0 : errors.limit) && ((_a = errors === null || errors === void 0 ? void 0 : errors.limit) === null || _a === void 0 ? void 0 : _a.message), maxLength: 2 }) })) })), (0, jsx_runtime_1.jsxs)(ButtonWrapper_1.default, Object.assign({ buttonPosition: "right" }, { children: [(0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ color: "cancel", onClick: handleClearSearchForm }, { children: "\u6E05\u9664\u689D\u4EF6" })), (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ color: "primary", onClick: handleSubmit(handleSubmitForm) }, { children: "\u67E5\u8A62" }))] }))] })) })));
};
exports.default = SearchForm;
